import React, { useEffect, useState } from 'react'
import DeleteTxnPopUp from './DeleteTxnPopup';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const DeleteButton = ({ txn_id }) => {
  const [showChip, setShowChip] = useState(false);
  const [showPopup, setShowPopup] = useState(false)
  const deleteResponse = useSelector((state) => state.deleteTxn.deleteResponse)
  const [checkRes, setCheckRes] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    if (checkRes && deleteResponse?.errors) {
      toast.error((Object.values(deleteResponse.errors)[0][0]), {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (checkRes && deleteResponse?.status) {
      toast.success("Transaction deleted successfully", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      navigate("/vendor_transactions")
    }
    setCheckRes(true)
  }, [deleteResponse])

  return (
    <>
      <div onClick={() => setShowPopup(true)}
        className="shadow-customCard
          flex items-center justify-center hover:opacity-80 text-black bg-white cursor-pointer
          p-2 rounded-4xl" >
        {showChip &&
          <div className='text-xs text-gray-800 transition-all px-2'>
            Delete/Archive
          </div>
        }
        <div onMouseEnter={() => setShowChip(true)} onMouseLeave={() => setShowChip(false)}
          className="w-4 h-4">
          <img src={require("../../../assets/TxnDetails/delete_txn.png")} alt="" />
        </div>
        </div>
      {showPopup &&
        <DeleteTxnPopUp txn_id={txn_id} setShowPopup={setShowPopup} />
      }
    </>
  )
}

export default DeleteButton
